import SelectBaseAntd, {
  SelectBaseAntdProps,
} from "ui/components/Input/SelectBaseAntd";

const SelectBase = (props: SelectBaseAntdProps) => (
  <SelectBaseAntd
    clearIcon
    allowClear
    size="large"
    placeholder="Selecione..."
    {...props}
  />
);

export default SelectBase;
